import { FormControl, FormLabel, Select } from '@mui/material';

import SelectPlaceholder from '../selectPlaceholder';

export const EmptySelect = ({
  title,
  size = 'small',
}: {
  title: string;
  size?: 'small' | 'medium' | 'large';
}) => {
  // todo: implement size on Select component and only forward 'size'
  const sx =
    size === 'large'
      ? { height: '58px' }
      : size === 'medium'
        ? { height: '48px' }
        : {};

  return (
    <FormControl size='small' className='flex-1'>
      {title && <FormLabel>{title}</FormLabel>}
      <Select
        sx={sx}
        displayEmpty
        renderValue={() => <SelectPlaceholder />}
        disabled
        value=''
      />
    </FormControl>
  );
};
